import React from 'react';
import PropTypes from 'prop-types';
import './RegistrationButton.css';

export const RegistrationButton = ({ onSubmitClick, sendingData }) => (
  <button
    name="submit"
    className="registration-button"
    type="submit"
    onClick={onSubmitClick}
  >
    {sendingData ? (
      <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
    ) : 'Register For Leap'}
  </button>
);

RegistrationButton.propTypes = {
  onSubmitClick: PropTypes.func,
  sendingData: PropTypes.bool,
};

RegistrationButton.defaultProps = {
  onSubmitClick: () => { },
  sendingData: false,
};
